import { render, staticRenderFns } from "./PDTChangeCommentSection.vue?vue&type=template&id=083cd9d0&scoped=true&"
import script from "./PDTChangeCommentSection.vue?vue&type=script&lang=ts&"
export * from "./PDTChangeCommentSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cd9d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSelect,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083cd9d0')) {
      api.createRecord('083cd9d0', component.options)
    } else {
      api.reload('083cd9d0', component.options)
    }
    module.hot.accept("./PDTChangeCommentSection.vue?vue&type=template&id=083cd9d0&scoped=true&", function () {
      api.rerender('083cd9d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/components/PDTChangeCommentSection.vue"
export default component.exports